// @ts-strict-ignore
import React, { FC } from 'react'
import Modal from '../modal'
import { IonCard, IonCardContent, IonText } from '@ionic/react'
import Button from '../Button'
import strings from 'mobile_web/strings'
import './styles.less'

interface ConfirmationModalProps {
	isOpen: boolean
	onDidDismiss?: () => void
	onAccept?: () => void
	question?: string
}

const ConfirmationModal: FC<ConfirmationModalProps> = ({ isOpen, onDidDismiss, onAccept, question }) => (
	<Modal isOpen={isOpen} onDidDismiss={onDidDismiss} cssClass="confirmation-modal">
		<IonCard>
			<IonCardContent>
				<div className="confirmation-modal-text">
					<i className="far fa-circle-exclamation" />
					<IonText>{question}</IonText>
				</div>
				<div>
					<Button fill="clear" ariaLabel={strings.close} onClick={onDidDismiss}>
						{strings.cancel}
					</Button>
					<Button fill="clear" ariaLabel={strings.close} onClick={onAccept} className="-submit">
						{strings.submit}
					</Button>
				</div>
			</IonCardContent>
		</IonCard>
	</Modal>
)

export default ConfirmationModal
